<template>
  <div>
    <div
      v-if="hasUnpaidInvoice || hasShippingOrderThatRequireAttention || hasItemThatRequiresFullfillment"
      class="accountNotificationBadge"
    />
    <div class="accountMenuLink">
      <a
        class="colorBlack"
        @click="clickAccountMenu()"
      >{{ accountMenuText }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccountMenuItem',
  computed: {
    authenticated: function () {
      return this.$store.getters.isAuthenticated
    },

	hasShippingOrderThatRequireAttention: function () {
		return this.$store.getters.hasShippingOrderThatRequiresAttention
	},
	hasUnpaidInvoice: function () {
		return this.$store.getters.hasUnpaidInvoice
	},
	hasItemThatRequiresFullfillment: function () {
		return this.$store.getters.hasItemThatRequiresFullfillment
	},

    accountMenuText: function () {
		if (this.authenticated) {
			return 'Account'
		}
		return 'Sign in'
    }
  },
	methods: {
		clickAccountMenu () {
			let payload = {
					'component': 'SignIn',
					'props': []
			}
			if (this.authenticated) {
				payload.component = 'AccountPage'
			}

			// show the modal
			this.$store.dispatch('showModal', payload)
		}
	}
}
</script>

<style scoped>
</style>
